"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const S = __importStar(require("./Button.styles"));
const Spinner_1 = __importDefault(require("../Spinner/Spinner"));
exports.default = (props) => {
    const { children, type = 'secondary', onPress, icon, size = 'normal', centeredIcon, disabled = false, accessibilityLabel, accessibilityHint, testID, ref, color, loading, loadingColor, } = props;
    return (react_1.default.createElement(S.Button, { color: color, type: type, size: size, ref: ref, onPress: onPress, testID: testID || `${type}Button`, accessible: true, accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, accessibilityRole: "button", disabled: disabled },
        icon && !centeredIcon && react_1.default.createElement(S.ButtonIcon, null, icon),
        loading && react_1.default.createElement(Spinner_1.default, { active: true, color: loadingColor }),
        !loading && (react_1.default.createElement(S.Text, { disabled: disabled, type: type, icon: icon && !centeredIcon ? true : undefined, size: size },
            icon && centeredIcon && (react_1.default.createElement(S.ButtonIconCenter, null, icon)),
            children))));
};
